import { defineStore } from "pinia";
export const useColegioStore = defineStore("colegio", {
    state: () => ({
        selectedColegio: (() => {
            const raw = localStorage.getItem("selectedColegio");
            if (!raw)
                return null;
            try {
                return JSON.parse(raw);
            }
            catch {
                return null;
            }
        })(),
    }),
    actions: {
        setColegio(colegio) {
            this.selectedColegio = colegio;
            localStorage.setItem("selectedColegio", JSON.stringify(colegio));
        },
        clearColegio() {
            this.selectedColegio = null;
            localStorage.removeItem("selectedColegio");
        },
    },
});
